import styled from "styled-components";
import {Colors} from "common/Theme";
import Helpers from "common/Theme/Helpers";

export const ContentStyle = styled.div`
  @media (min-width: 768px) {
    position: sticky;
    top: 72px;
    z-index: 4;
    background: #fff;
  }
`;